/* =================================================================================================
 * Grille de produits (campus-products) — décors en mode « pluie ».
 *
 * Le gabarit Liquid pose plusieurs exemplaires de chaque décor ; ce script les
 * rend tous différents. À CHAQUE chute, un élément tire au sort :
 *   - sa colonne (sur téléphone et sur ordinateur) ;
 *   - la durée de sa chute (autour de la durée réglée dans la section) ;
 *   - sa taille (70 à 125 %) et son sens (retourné ou non), pour que deux
 *     exemplaires d'une même feuille ne se ressemblent pas ;
 *   - son balancement et l'angle de départ ;
 *   - une courte pause avant de retomber.
 * À l'ouverture de la page, chacun démarre à un point différent de sa chute,
 * pour que la pluie soit déjà installée.
 *
 * La chute elle-même reste une animation CSS (une seule par tirage) : le
 * script n'intervient qu'entre deux chutes.
 * ===============================================================================================*/

(function () {
  'use strict';

  var hasard = function (min, max) { return min + Math.random() * (max - min); };

  function tirer(el, duree, premiere) {
    var d = duree * hasard(0.8, 1.4);
    el.style.setProperty('--x', hasard(3, 97).toFixed(1));
    el.style.setProperty('--xd', hasard(2, 98).toFixed(1));
    el.style.setProperty('--duree', d.toFixed(2) + 's');
    el.style.setProperty('--balance', hasard(2.5, 5).toFixed(2) + 's');
    el.style.setProperty('--k', hasard(0.7, 1.25).toFixed(2));
    el.style.setProperty('--flip', Math.random() < 0.5 ? -1 : 1);
    el.style.setProperty('--r', Math.round(hasard(-60, 60)) + 'deg');
    // Première chute : déjà en cours, à un point au hasard. Ensuite : pause.
    el.style.setProperty('--depart', premiere ? (-hasard(0, d)).toFixed(2) + 's' : hasard(0.3, 3).toFixed(2) + 's');

    // Relance de l'animation de chute avec les nouvelles valeurs.
    el.classList.remove('campus-products__decor--rain');
    void el.offsetWidth;
    el.classList.add('campus-products__decor--rain');
  }

  function demarrer(section) {
    if (section.dataset.pluiePrete) return;
    section.dataset.pluiePrete = '1';
    var duree = parseFloat(section.dataset.rainSpeed) || 12;

    section.querySelectorAll('[data-rain]').forEach(function (el) {
      tirer(el, duree, true);
      el.addEventListener('animationend', function (evt) {
        if (evt.target === el && evt.animationName === 'cpr-chute') tirer(el, duree, false);
      });
    });
  }

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function tout() { document.querySelectorAll('[data-rain-speed]').forEach(demarrer); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tout);
  else tout();
  // Éditeur de thème : une section rechargée doit repartir.
  document.addEventListener('shopify:section:load', tout);
})();
